import * as types from './types/getters';

export default {
    [types.GET_CHAPTERS]: state => state.chapters,
    [types.GET_CHAPTER]: state => state.chapter,
    [types.GET_ARTISTS]: state => state.artists
};
